import * as React from 'react';
import { CoreDivider } from '../CoreDivider';
import { classes } from './CoreDropdownOption.st.css';
import uniqueId from 'lodash/uniqueId';
import compact from 'lodash/compact';
const createOption = (option = null) => {
    return {
        id: option && (option.id || option.id === 0) ? option.id : uniqueId('Option'),
        isDisabled: false,
        isSelectable: true,
        unavailable: false,
        value: null,
        render: (val) => val,
        role: 'option',
        ...option,
    };
};
const escapeRegExp = (s) => s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
const highlightRegExt = (s) => new RegExp(`(${s.replace(/ /g, '|')})`, 'gi');
const isEven = (i) => i % 2 === 0;
const isOdd = (i) => i % 2 === 1;
const highlightMatches = (option, searchTerm) => {
    const regExp = highlightRegExt(escapeRegExp(searchTerm.trim()));
    const stringArray = option.value.split(regExp);
    const f = stringArray[0] === '' ? isEven : isOdd;
    const parts = compact(stringArray).map((part, i) => f(i) ? (React.createElement("mark", { className: classes.highlight, key: i }, part)) : (React.createElement("span", { className: classes.nonHighlight, key: i }, part)));
    return createOption({
        id: option.id,
        isDisabled: option.isDisabled,
        isSelectable: option.isSelectable,
        value: option.value,
        render: () => option.render(parts),
    });
};
export const OptionFactory = {
    create: createOption,
    createDivider({ className, value } = {}) {
        return createOption({
            id: uniqueId('Divider'),
            isDisabled: false,
            isSelectable: false,
            render: value
                ? () => React.createElement(CoreDivider, { className: className }, value)
                : () => React.createElement(CoreDivider, { className: className }),
        });
    },
    createHighlighted(option, highlightValue) {
        return option.value && highlightValue
            ? highlightMatches(option, highlightValue)
            : option;
    },
};
//# sourceMappingURL=OptionFactory.js.map